import { Dimensions, StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  // Carousel container styles
  carouselContainer: {
    justifyContent: "center",
  },
  carouselImage: {
    height: "100%",
    resizeMode: "contain",
    width: "100%",
  },
  carouselImageContainer: {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
  },
  // Details container for tier description and benefits
  detailsContainer: {
    backgroundColor: colors.background,
    // borderTopLeftRadius: 50,
    // borderTopRightRadius: 50,
    padding: 20,
  },

  // Header container styles
  headerContainer: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },

  paginationDotContainer: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },

  // New styles for tier details and benefits
  benefitContainer: {
    alignItems: "center",
    backgroundColor: colors.palette.lightGray,
    borderRadius: 10,
    flexDirection: "row",
    marginVertical: 10,
    padding: 10,
  },
  benefitDescription: {
    color: colors.palette.gray,
    fontSize: 14,
  },
  benefitImage: {
    borderRadius: 100,
    height: 50,
    marginRight: 15,
    resizeMode: "contain",
    width: 50,
  },
  benefitTitle: {
    color: colors.palette.darkGray,
    fontSize: 18,
    fontWeight: "bold",
  },
  tierTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 24,
    fontWeight: "bold",
    marginVertical: 10,
  },

  tierBoxFlex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 15,
  },
  tierBoxRight: {
    width: "70%",
    height: "100%",
  },
  TierTitleContainer: {
    display: "flex",
    width: "100%",
  },
  tierTitle2: { fontFamily: typography.primary.normal, fontSize: 28 },
  benefitText: {
    fontFamily: typography.primary.normal,
    marginBottom: "3%",
  },
  pointImage: {
    width: 30,
    height: 30,
    resizeMode: "contain",
    marginRight: 15,
  },
  textContainer: { alignSelf: "flex-start", fontSize: 12, marginBottom: 5 },
  text: { fontFamily: typography.primary.normal, marginTop: 10, alignSelf: "flex-end" },
  borderContainer: {
    marginBottom: 10,
    elevation: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6,

    // Border for light edge effect
    borderColor: "#d9d9d9",
    borderRadius: 10,
  },

  tierText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    marginBottom: 10,
  },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },
  container: { height: "100%" },
  dividerView: {
    borderColor: colors.lightGrey,
    borderRadius: 1,
    borderStyle: "dashed",
    borderWidth: 1,
    height: 1,
    marginVertical: 10,
    width: "100%",
    zIndex: 1,
  },
  dividerViewStyle: {
    backgroundColor: colors.white,
    bottom: 0,
    height: 1,
    left: 0,
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  expiryText: {
    color: colors.darkerGrey,
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginTop: 5,
  },
  flatListContainer: {
    padding: 10,
  },
  header: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10 },
  headerTabBarContainer: {
    alignSelf: "center",
    borderColor: colors.white,
    borderRadius: 20,
    borderWidth: 1,
    flexDirection: "row",
    height: 30,
    width: "90%",
  },
  image: {
    alignSelf: "center",
    borderRadius: 10,
    height: 50,
    marginRight: 10,
    width: 50,
  },
  linearGradient: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10, paddingTop: 10 },
  mb20: { marginBottom: 20 },
  row: { alignItems: "center", flexDirection: "row" },
  selectedTabBar: {
    backgroundColor: colors.white,
    borderRadius: 30,
    margin: 1,
  },
  tabBar: { alignItems: "center", flex: 1, justifyContent: "center" },
  voucherContainer: {
    backgroundColor: colors.white,
    borderRadius: 10,
    elevation: 1,
    marginHorizontal: 5,
    marginTop: 20,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
  },
  voucherDescription: {
    color: colors.darkerGrey,
    fontFamily: typography.primary.normal,
    fontSize: 12,
  },
  tierContentContainer: { borderRadius: 10, marginTop: 10, padding: 20, paddingLeft: 0 },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
})
